import { render, staticRenderFns } from "./XGridTree.vue?vue&type=template&id=136504fa&scoped=true&"
import script from "./XGridTree.vue?vue&type=script&lang=js&"
export * from "./XGridTree.vue?vue&type=script&lang=js&"
import style0 from "./XGridTree.vue?vue&type=style&index=0&id=136504fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136504fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('136504fa')) {
      api.createRecord('136504fa', component.options)
    } else {
      api.reload('136504fa', component.options)
    }
    module.hot.accept("./XGridTree.vue?vue&type=template&id=136504fa&scoped=true&", function () {
      api.rerender('136504fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grid/XGridTree.vue"
export default component.exports